import { useMutation } from "@tanstack/react-query";

import { useCrmEnrichmentJobCache } from "../../hooks/useCrmEnrichmentJobCache";
import type { ICrmEnrichmentAPIService } from "../../services/api/types";
import type { CrmEnrichmentJob } from "../../types/types";
import type { ICrmEnrichmentQueryKeyFactory } from "../key-factory/types";

type MutationDependencies = {
    readonly apiService: ICrmEnrichmentAPIService;
    readonly queryKeys: ICrmEnrichmentQueryKeyFactory;
    readonly onSuccessCallback?: (data: CrmEnrichmentJob, job: CrmEnrichmentJob) => void;
};

export const useCrmEnrichmentJobRemoveMutation = ({
    apiService,
    queryKeys,
    onSuccessCallback,
}: MutationDependencies) => {
    const { removeJobFromCache } = useCrmEnrichmentJobCache(queryKeys);

    return useMutation<CrmEnrichmentJob, unknown, CrmEnrichmentJob>({
        mutationFn(job) {
            return apiService.removeJob(job.id);
        },
        onSuccess(data, job) {
            removeJobFromCache(job);
            onSuccessCallback?.(data, job);
        },
    });
};
